/*
 * Project: bellcloud
 * File: apps/frontend/src/utils/alarmSound.ts
 * Description: 사이트 내 알람(low/high/twa/stel) 발생 기기가 있는 동안 경보음 반복 재생
 */

import { useSettingsStore } from '@/store/settingsStore';

const ALARM_SOUND_SRC = '/audios/low_alarm.m4a';

let alarmAudio: HTMLAudioElement | null = null;

function getAudio(): HTMLAudioElement | null {
  if (typeof window === 'undefined' || typeof Audio === 'undefined') return null;
  if (!alarmAudio) {
    alarmAudio = new Audio(ALARM_SOUND_SRC);
    alarmAudio.preload = 'auto';
  }
  return alarmAudio;
}

/**
 * 알람 경보음 반복 재생 시작.
 * - 설정(alarmSoundEnabled)이 꺼져 있으면 재생하지 않는다.
 * - 이미 재생 중이면 그대로 둔다(중복 재생 방지).
 * - 브라우저 autoplay 정책으로 차단될 수 있으므로 play() 실패는 무시한다.
 */
export function startAlarmLoop(): void {
  if (!useSettingsStore.getState().alarmSoundEnabled) return;

  const audio = getAudio();
  if (!audio) return;

  audio.loop = true;

  // 이미 재생 중이면 중복 호출 무시
  if (!audio.paused) return;

  try {
    audio.currentTime = 0;
    void audio.play().catch(() => {
      // 사용자 제스처 전이거나 autoplay 차단 시 무시
    });
  } catch {
    // Audio 미지원 환경 등 — 무시
  }
}

/**
 * 알람 경보음 반복 재생 정지.
 */
export function stopAlarmLoop(): void {
  const audio = alarmAudio;
  if (!audio) return;

  try {
    audio.pause();
    audio.currentTime = 0;
  } catch {
    // 무시
  }
}

/**
 * 사용자 제스처(설정 토글 클릭 등) 중에 호출하여 autoplay 정책을 해제하고
 * 경보음을 1회 미리 재생한다. 이후 비제스처 재생(반복 루프)이 허용된다.
 */
export function previewAndUnlockAlarmSound(): void {
  const audio = getAudio();
  if (!audio) return;

  try {
    audio.loop = false;
    audio.currentTime = 0;
    void audio.play().catch(() => {
      // 차단 시 무시
    });
  } catch {
    // 무시
  }
}
